import React from "react";
import style from "./VideoComponent.module.css";
import { aboutUsOrnament, videoOrnament } from "../../assets";

export default function VideoComponent(props) {

    // DEMO prop-object 
    // props = { heading: "Heading", content: "Content" }
    
    return(
        <div className={style.VideoComponent_container}>
            <p>{props?.heading}</p>
            <p>{props?.content}</p>
            {/* <div className={style.Video_container}>

            </div> */}
            {/* <video width="100%" controls playsInline preload="metadata" className={style.video}>
                <source 
                    type="video/mp4"
                    src="https://admin-api.nufolks.com/public/assets/videos/NuFolks_Walkthrough_Final_Video.mp4" 
                />
                <track src="captions.vtt" kind="subtitles" srclang="en" label="English" default />
                Your browser does not support the video tag.
            </video> */}
            <div className={style.videoWrapper} data-aos="fade-up">
                <img className={style.videoOrnament} style={{zIndex: "1"}} src={videoOrnament} alt="" />
                {/* <video controls playsinline preload="metadata">
                    <source 
                        type="video/mp4"
                        src="https://admin-api.nufolks.com/public/assets/videos/NuFolks_Walkthrough_Final_Video.mp4" 
                    />
                    Your browser does not support the video tag.
                </video> */}
                <iframe 
                    className={style.videoWrapper_iframe}
                    src="https://www.youtube.com/embed/vR0NwOEBkoE?si=FxLCIr7zfeTYChg0"
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                    referrerpolicy="strict-origin-when-cross-origin" 
                    allowFullScreen
                ></iframe>
                <img className={style.videoOrnament} style={{zIndex: "1"}} src={videoOrnament} alt="" />
            </div>
        </div>
    )
}